<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="handleClick" type="card">
      <el-tab-pane name="Request">
        <div slot="label" class="label-custom">
          <i class="icon icon24-CongViec"></i>
          <span>Yêu cầu</span>
        </div>
        <div v-if="activeTab == 'Request'">
          <div class="search-block mb-3">
            <div class="d-flex">
              <div class="status-filter mr-3">
                <el-select
                  v-model="dataSearch.status"
                  placeholder="Chọn trạng thái"
                  @change="fn_search()"
                >
                  <el-option
                    v-for="item in listTrangThhai"
                    :key="item.value"
                    :label="item.label"
                    :value="item.name"
                  />
                </el-select>
              </div>
              <div class="created-time d-flex">
                <p class="flex-shink first-title">Thời gian từ</p>
                <el-date-picker
                  class="flex-shink"
                  ref="from_date"
                  v-model="dataSearch.from_date"
                  type="date"
                  placeholder="Chọn ngày"
                  format="dd/MM/yyyy"
                  @change="checkChangeFromDate()"
                />
                <p class="flex-shink second-title ml-2">đến</p>
                <el-date-picker
                  ref="to_date"
                  class="flex-shink"
                  v-model="dataSearch.to_date"
                  type="date"
                  placeholder="Chọn ngày"
                  format="dd/MM/yyyy"
                  @change="checkChangeToDate()"
                />
              </div>
            </div>
          </div>
          <div class="data-table">
            <Table
              :dataTable="listRequests"
              :defaultSort="tableRules.defaultSort"
              :activeTab="activeTab"
              @handleClick="fn_handle"
              @tableSortChange="fn_tableSortChange"
            />
            <b-row class="mt-2">
              <b-col md="12" class="text-right">
                <Pagination
                  :page="tableRules.page"
                  :total="tableRules.total"
                  :limit="tableRules.limit"
                  :offset="tableRules.offset"
                  @changePagination="changePagination"
                />
              </b-col>
            </b-row>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane name="Approve" v-if="MethodService.checkHaveFeature('FT1006')">
        <div slot="label" class="label-custom">
          <i class="icon icon24-Group"></i>
          <span>Phê duyệt</span>
        </div>
        <div v-if="activeTab == 'Approve'">
          <div class="search-block mb-3">
            <div class="d-flex">
              <div class="status-filter mr-3">
                <el-select
                  v-model="dataSearch.status"
                  disabled
                  placeholder="Chọn trạng thái"
                  @change="fn_search()"
                >
                  <el-option
                    v-for="item in listTrangThhai"
                    :key="item.value"
                    :label="item.label"
                    :value="item.name"
                  />
                </el-select>
              </div>
              <div class="created-time d-flex">
                <p class="flex-shink first-title">Thời gian từ</p>
                <el-date-picker
                  class="flex-shink"
                  ref="from_date"
                  v-model="dataSearch.from_date"
                  type="date"
                  placeholder="Chọn ngày"
                  format="dd/MM/yyyy"
                  @change="checkChangeFromDate()"
                />
                <p class="flex-shink second-title ml-2">đến</p>
                <el-date-picker
                  ref="to_date"
                  class="flex-shink"
                  v-model="dataSearch.to_date"
                  type="date"
                  placeholder="Chọn ngày"
                  format="dd/MM/yyyy"
                  @change="checkChangeToDate()"
                />
              </div>
            </div>
          </div>
          <div class="data-table">
            <Table
              :dataTable="listRequestNeedApproves"
              :defaultSort="tableRules.defaultSort"
              :activeTab="activeTab"
              @handleClick="fn_handle"
              @tableSortChange="fn_tableSortChange"
            />
            <b-row class="mt-2">
              <b-col md="12" class="text-right">
                <Pagination
                  :page="tableRules.page"
                  :total="tableRules.total"
                  :limit="tableRules.limit"
                  :offset="tableRules.offset"
                  @changePagination="changePagination"
                />
              </b-col>
            </b-row>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import EmployeeRequestApi from "../../../moduleApi/EmployeeRequestApi"
import DataService from "../../../service/DataService"
import LanguageService from "../../../service/LanguageService"
import MethodService from "../../../service/MethodService"
import Pagination from "../../../component/Pagination/Pagination"
import Table from "./components/Table"
import RequestsModel from './RequestsModel'
import { Filter } from "mushroomjs"
import toastr from "toastr"

export default {
  components: {
    Pagination,
    Table,
  },
  data() {
    return {
      DataService,
      LanguageService,
      MethodService,
      activeTab: 'Request',
      listRequests: [],
      listRequestNeedApproves: [],
      currentUser: MethodService.getCurrentUser(),
      tableRules: MethodService.copyObject(RequestsModel.tableRulePersonal),
      listTrangThhai: RequestsModel.listTrangThai,
      heightTable: window.innerHeight - 290,
      dataSearch: {
        status: 'ALL',
        from_date: undefined,
        to_date: undefined,
      }
    }
  },
  methods: {
    // A function to get list request from API.
    async getListRequest() {
      console.log('this.tableRules.limit', JSON.stringify(this.tableRules.limit))
      let dataFiler = {
        filters: this.tableRules.filters ? `${this.tableRules.filters}&employee_id=${this.currentUser.id}` : `employee_id=${this.currentUser.id}`,
        sort: this.tableRules.sort,
        offset: this.tableRules.offset,
        limit: this.tableRules.limit
      }
      const resApiListRequest = await EmployeeRequestApi.list(dataFiler)
      this.listRequests = resApiListRequest.result
      this.tableRules.total = resApiListRequest.meta.total
      this.tableRules.page =
        this.tableRules.offset / this.tableRules.limit + 1
      this.changeRoute()
    },
    // The above code is a function that is called when the page is loaded. It is used to get the data
    // from the API and display it on the page.
    async getRequestNeedApprove() {
      let dataFiler = {
        tab: 'REQUEST_APPROVER',
        limit: this.tableRules.limit,
        skip: this.tableRules.offset,
        from: this.dataSearch.from_date,
        to: this.dataSearch.to_date,
        sort: this.tableRules.sort
      }
      const resApiRequestNeedApprove = await EmployeeRequestApi.GetEmployeeRequestByStatus(dataFiler)
      this.listRequestNeedApproves = resApiRequestNeedApprove.result
      this.tableRules.total = resApiRequestNeedApprove.meta.total
      this.tableRules.page =
        this.tableRules.offset / this.tableRules.limit + 1
      this.changeRoute()
    },
    // A function to check the date.
    checkChangeFromDate() {
      if (
        this.dataSearch.from_date &&
        this.dataSearch.to_date &&
        new Date(this.dataSearch.from_date).getTime() > new Date(this.dataSearch.to_date).getTime()
      ) {
        toastr.warning(`"Thời gian từ" phải bé hơn hoặc bằng "Thời gian đến"`)
        this.dataSearch.from_date = undefined
        this.$refs['from_date'].focus()
        return
      }
      this.fn_search()
    },
    // A function to check the date.
    checkChangeToDate() {
      if (
        this.dataSearch.from_date &&
        this.dataSearch.to_date &&
        new Date(this.dataSearch.from_date).getTime() > new Date(this.dataSearch.to_date).getTime()
      ) {
        toastr.warning(`"Thời gian đến" phải lớn hơn hoặc bằng "Thời gian từ"`)
        this.dataSearch.to_date = undefined
        this.$refs['to_date'].focus()
        return
      }
      this.fn_search()
    },
    // A function to handle the event when the pagination is changed.
    changePagination(data) {
      this.tableRules.page = data.page
      this.tableRules.offset = data.offset
      this.tableRules.limit = data.limit
      this.activeTab == 'Request' ? this.getListRequest() : this.getRequestNeedApprove()
    },
    // It's a function to filter data.
    fn_search() {
      if (this.activeTab == 'Approve') {
        this.tableRules.offset = 0
        this.tableRules.page = 1
        this.getRequestNeedApprove()
        return
      }
      let filter = Filter.empty()
      if (this.dataSearch.status && this.dataSearch.status != 'ALL' ) filter = filter.eq('status', this.dataSearch.status)
      if (this.dataSearch.from_date) filter = filter.gte('created_at', this.dataSearch.from_date)
      if (this.dataSearch.to_date) filter = filter.lte('created_at', this.dataSearch.to_date)
      this.tableRules.filters = filter.build()
      this.tableRules.offset = 0
      this.tableRules.page = 1
      this.getListRequest()
    },
    // It's a function to filter data.
    fn_defaultSearch() {
      if (this.activeTab == 'Approve') {
        this.getRequestNeedApprove()
        return
      }
      let filter = Filter.empty()
      if (this.dataSearch.status && this.dataSearch.status != 'ALL' ) filter = filter.eq('status', this.dataSearch.status)
      if (this.dataSearch.from_date) filter = filter.gte('created_at', this.dataSearch.from_date)
      if (this.dataSearch.to_date) filter = filter.lte('created_at', this.dataSearch.to_date)
      this.tableRules.filters = filter.build()
      this.getListRequest()
    },
    // The above code is a method that is called when the user clicks on a tab.
    handleClick() {
      this.tableRules = {
        filters: '',
        limit: 20,
        offset: 0,
        page: 1,
        total: 0,
        sort: this.activeTab == 'Request' ? '-created_at' : ''
      }
      this.dataSearch = {
        from_date: undefined,
        to_date: undefined,
      }
      if (this.activeTab == 'Request') {
        this.dataSearch.status = 'ALL'
        this.getListRequest()
      }
      if (this.activeTab == 'Approve') {
        this.dataSearch.status = 'WAITING_FOR_APPROVAL'
        this.getRequestNeedApprove()
      }
      this.changeRoute()
    },
    // A function to handle click event on button detail.
    fn_handle(data) {
      if (!data) return
      if (data.type == 'detail') {
        this.$router.push({
          name: 'Admin-ManageRequests-CheckRequest',
          params: { id: data.rowId }
        })
      }
    },
    fn_tableSortChange(data) {
      this.tableRules.sort = data.sort == ''
        ?  this.activeTab == 'Request'
          ? '-created_at'
          :  data.sort
        : data.sort
      this.activeTab == 'Request' ? this.getListRequest() : this.getRequestNeedApprove()
    },
    // Changing the route to the current route with the query parameter tab.
    changeRoute() {
      this.$router.replace({
        name: 'Admin-Personal-Request',
        query: {
          tab: this.activeTab,
          limit: this.tableRules.limit,
          page: this.tableRules.page,
          sort: this.tableRules.sort,
          status: this.dataSearch.status,
          from_date: this.dataSearch.from_date ? new Date(this.dataSearch.from_date).toISOString() : this.dataSearch.from_date,
          to_date: this.dataSearch.to_date ? new Date(this.dataSearch.to_date).toISOString() : this.dataSearch.to_date,
        }
      }).catch(() => {})
    },
    // A function to get the value of the tab from the URL.
    fn_hashUrl() {
      if (this.$route.query.tab) {
        if (this.$route.query.tab == 'Approve' && MethodService.checkHaveFeature('FT1006')) {
          this.activeTab = this.$route.query.tab
        } else {
          this.activeTab = 'Request'
        }
      }
      if (this.$route.query.limit) this.tableRules.limit = parseInt(this.$route.query.limit)
      if (this.$route.query.sort) this.tableRules.sort = this.$route.query.sort
      if (this.$route.query.page) this.tableRules.page = parseInt(this.$route.query.page)
      if (this.$route.query.page && this.$route.query.limit) {
        this.tableRules.offset = (this.$route.query.page - 1) * this.$route.query.limit
      }
      if (this.$route.query.status) this.dataSearch.status = this.$route.query.status
      if (this.$route.query.from_date) this.dataSearch.from_date = this.$route.query.from_date
      if (this.$route.query.to_date) this.dataSearch.to_date = this.$route.query.to_date
    },
  },
  created() {
    this.fn_hashUrl()
  },
  mounted() {
    this.fn_defaultSearch()
  }
}
</script>

<style lang="scss" scoped>
h1, h2, h3, h4, h5, h6, p, span {
  font-family: 'LexendDeca Regular' !important
}
::v-deep .el-tabs--card>.el-tabs__header {
  border-bottom: none;
  margin-bottom: 0;
}
::v-deep .el-tabs {
  .el-tabs__header {
    .el-tabs__nav {
      display: flex;
      .el-tabs__item {
        margin-right: 0;
        background: #E9E9E9;
        border-radius: 0;
        border-bottom: 3px solid #D0D5D9;
        height: 50px;
        display: flex;
        padding: 0;
        .label-custom {
          display: flex;
          align-items: center;
          margin: 8px 0;
          padding: 0 30px;
          color: #292D32;
          .icon {
            margin-right: 10px
          }
          span {
            color: #292D32;
            font-weight: 300;
            font-size: 15px;
            line-height: 24px;
          }
        }
        &.is-active {
          background-color: #FFFFFF !important;
          border: none;
          border-top: 3px solid #F79E61;
          .label-custom {
            border: none;
          }
        }
      }
    }
  }
  .el-tabs__content {
    min-height: calc(100vh - 160px);
    padding: 20px;
    position: relative;
    background: var(--white);
  }
}

.search-block {
  .status-filter {
    max-width: 200px;
  }
  .created-time {
    align-items: center;
    .flex-shink {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: 250px;
      &:nth-child(1) {
        flex-basis: 95px;
      }
      &:nth-child(3) {
        flex-basis: 40px;
      }
    }
  }
}

@media (max-width: 767px) {
  ::v-deep .el-tabs {
    .el-tabs__content {
      padding-left: 0;
      padding-right: 0;
      overflow: hidden;
    }
  }

  .search-block {
    padding-left: 20px;
    padding-right: 20px;

    > .d-flex {
      flex-wrap: wrap;
      gap: 12px;
    }

    .status-filter {
      width: 100%;
      max-width: none;
      margin-right: 0 !important;
    }

    .created-time {
      width: 100%;
      flex-wrap: wrap;
      gap: 8px;

      .flex-shink {
        flex-basis: calc(50% - 24px);

        &:nth-child(1) {
          flex-basis: 100%;
        }

        &:nth-child(3) {
          flex-basis: 32px;
          margin-left: 0 !important;
          text-align: center;
        }
      }

      .el-date-editor.el-input {
        width: auto;
      }
    }
  }

  .data-table {
    ::v-deep .el-table {
      max-height: none !important;
    }

    ::v-deep .el-table__body-wrapper {
      max-height: none !important;
      overflow-y: visible !important;
    }

    .row {
      margin-left: 0;
      margin-right: 0;
    }

    .col-md-12 {
      padding-left: 0;
      padding-right: 0;
    }

    ::v-deep .el-pagination {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      white-space: normal;
      row-gap: 8px;
    }
  }
}
</style>
